export const environment = {
  production: false,
  ENV: 'qa',
  BASE_BACKEND: 'https://video-ipp-qa.afpcapital.cl/bff',
  INDIVIDEO_DEPLOYMENT_CODE: 'Qw6KW5WwSMmAvw-18236',
  INDIVIDEO_URL: 'https://cdn.individeo.com/individeo/prod/edge/js/smartEmbed.js',
  RECAPTCHA_KEY: '6Ldg-V8sAAAAAAVEN96jWrd16Kg4ew2WupSTzNAO',
  ENABLE_RECAPTCHA: true,
  LOGROCKET_APP_ID: '',
  ENABLE_LOGROCKET: false,
};
